<template>
  <div class="page relate-protocol">
    <navigation>相关协议</navigation>
    <div class="header">
      <p class="description"></p>
    </div>
    <nd-cell class="navigate-item" v-for="(item, index) in signList" :id="index" :key="index" :title="item.title" @click="clickProtocol(item)"></nd-cell>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import { getKey } from '../../assets/utils'
export default {
  name: 'relate-protocol',
  customReadyNotify: true,
  data () {
    return {
      signList: [],
      loanPlatform: this.$route.query.loanPlatform
    }
  },

  async created () {
    try {
      await this.getOrderSignList()
      this.$bus.$emit('ready')
    } catch (exp) {
      this.$bus.$emit('error')
    }
  },

  methods: {
    ...mapActions('order', ['getOrderSignListX']),
    companyTitle () {
      if (this.loanPlatform === 'LFQ') {
        return '无界'
      } else if (this.loanPlatform === 'YZD') {
        return '崇天小贷'
      } else {
        return ''
      }
    },

    // 获取签章列表
    async getOrderSignList () {
      const response = await this.getOrderSignListX(this.$route.query)
      if (response.success === true) {
        this.signList = response.data.filter(item => !!item)
      }
    },

    clickProtocol (item) {
      const origin = process.env.VUE_APP_PROURL
      const gid = getKey('gid')
      const { mobile, userId } = getKey('userInfo') || {}
      window.location.href = `${origin}/protocol/src2pdf?file=${item.path}&title=${item.title}&gid=${gid}&userId=${userId}&phoneNumber=${mobile}&?exit=N`
    }
  }
}
</script>

<style lang="less">
@import "../../assets/less/mixin.less";

  .relate-protocol {
      background-color: #fafafa;

      .header {
          .description {
            color: @fc2;
            font-family: PingFangSC-Regular,PingFang SC;
            font-size: 26px;
            line-height: 100px;
            padding-left: 30px;
            font-weight: 400;
         }
      }

      .navigate-item {
          height: 110px;
          line-height: 110px;
          margin-top: 0px;
          padding-left: 15px;
          padding-right: 17px;
          border-bottom: 1px solid @iuc;
      }
  }
</style>